(function () {
  "use strict";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Sticky header shrink on scroll ---------- */
  var lastY = window.scrollY;
  function onScroll() {
    var y = window.scrollY;
    document.body.classList.toggle("oxselle-scrolled", y > 40);
    lastY = y;
    updateParallax();
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Hero parallax ---------- */
  var heroBanner = document.querySelector(".shopify-section .banner .banner__media");
  if (heroBanner && heroBanner.closest(".shopify-section")) {
    heroBanner.closest(".shopify-section").classList.add("oxselle-hero-parallax");
  }
  function updateParallax() {
    if (reduceMotion) return;
    var el = document.querySelector(".oxselle-hero-parallax .banner__media");
    if (!el) return;
    var rect = el.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    var offset = Math.round(rect.top * -0.12);
    el.style.setProperty("--oxselle-parallax-y", offset + "px");
  }

  /* ---------- Scroll reveal + stagger via IntersectionObserver ---------- */
  function markRevealTargets() {
    document.querySelectorAll(".shopify-section .rich-text, .shopify-section .banner__box").forEach(function (el) {
      el.classList.add("oxselle-reveal");
    });
    document.querySelectorAll(".multicolumn-list, .collection-list-wrapper .grid").forEach(function (el) {
      el.classList.add("oxselle-stagger");
    });
  }

  function initObserver() {
    if (reduceMotion || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".oxselle-reveal, .oxselle-stagger").forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".oxselle-reveal, .oxselle-stagger").forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Count-up stat numbers ---------- */
  function initCountUp() {
    var statBlocks = document.querySelectorAll(".multicolumn .multicolumn-card__info h3, .multicolumn-card__info .multicolumn-card__title");
    statBlocks.forEach(function (heading) {
      var raw = heading.textContent.trim();
      var match = raw.match(/^([\d.,]+)(\+|%)?$/);
      if (!match) return;
      var target = parseFloat(match[1].replace(/,/g, ""));
      var suffix = match[2] || "";
      heading.classList.add("oxselle-stat-value");
      heading.setAttribute("data-target", target);
      heading.setAttribute("data-suffix", suffix);
      heading.textContent = "0" + suffix;
    });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".oxselle-stat-value").forEach(function (el) {
        el.textContent = el.getAttribute("data-target") + el.getAttribute("data-suffix");
      });
      return;
    }

    var counted = new WeakSet();
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || counted.has(entry.target)) return;
          counted.add(entry.target);
          animateCount(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    document.querySelectorAll(".oxselle-stat-value").forEach(function (el) {
      io.observe(el);
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-target"));
    var suffix = el.getAttribute("data-suffix") || "";
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);
      el.textContent = value.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Custom Design form: drag-and-drop image preview ---------- */
  function initDropzone() {
    var textarea = document.getElementById("DesignReferenceNotes");
    if (!textarea) return;

    var mount = document.querySelector("[data-oxselle-shop-email]");
    var shopEmail = mount ? mount.getAttribute("data-oxselle-shop-email") : "";

    var wrapper = document.createElement("div");
    var noteText = shopEmail
      ? "Previews only \u2014 attach the same files to your email to " + shopEmail + "."
      : "Previews only \u2014 attach the same files to your email separately.";
    wrapper.innerHTML =
      '<div class="oxselle-dropzone" id="OxselleDropzone" tabindex="0" role="button" aria-label="Upload reference images">' +
      "<p>Drag &amp; drop reference images here, or click to choose files</p>" +
      '<p style="opacity:.6; font-size:.85rem; margin-top:.25rem;">' + noteText + '</p>' +
      '<input type="file" id="OxselleFileInput" accept="image/*" multiple>' +
      '</div><div class="oxselle-preview-grid" id="OxsellePreviewGrid"></div>';

    var target = textarea.closest(".field");
    while (wrapper.firstChild) {
      target.parentNode.insertBefore(wrapper.firstChild, target);
    }

    var dropzone = document.getElementById("OxselleDropzone");
    var fileInput = document.getElementById("OxselleFileInput");
    var previewGrid = document.getElementById("OxsellePreviewGrid");
    var files = [];

    dropzone.addEventListener("click", function () {
      fileInput.click();
    });
    dropzone.addEventListener("keypress", function (e) {
      if (e.key === "Enter" || e.key === " ") fileInput.click();
    });
    ["dragenter", "dragover"].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        dropzone.classList.add("is-dragover");
      });
    });
    ["dragleave", "drop"].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        dropzone.classList.remove("is-dragover");
      });
    });
    dropzone.addEventListener("drop", function (e) {
      handleFiles(e.dataTransfer.files);
    });
    fileInput.addEventListener("change", function (e) {
      handleFiles(e.target.files);
    });

    function handleFiles(fileList) {
      Array.prototype.forEach.call(fileList, function (file) {
        if (!file.type.startsWith("image/")) return;
        files.push(file);
        var reader = new FileReader();
        reader.onload = function (e) {
          var fig = document.createElement("figure");
          var img = document.createElement("img");
          img.src = e.target.result;
          var btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("aria-label", "Remove image");
          btn.textContent = "\u00d7";
          btn.addEventListener("click", function () {
            fig.remove();
            files = files.filter(function (f) {
              return f !== file;
            });
            updateNotes();
          });
          fig.appendChild(img);
          fig.appendChild(btn);
          previewGrid.appendChild(fig);
          updateNotes();
        };
        reader.readAsDataURL(file);
      });
    }

    function updateNotes() {
      textarea.value = files.map(function (f) {
        return f.name;
      }).join(", ");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    markRevealTargets();
    initObserver();
    initCountUp();
    initDropzone();
    updateParallax();
  });
})();
